export const translations = {
  es: {
    // Header
    nav: {
      inicio: 'Inicio',
      portfolio: 'Portfolio',
      proyectos: 'Proyectos',
      proceso: 'Proceso',
      sobreMi: 'Sobre mí',
      dondeEstoy: '¿Dónde estoy?',
      contacto: 'Contacto',
      reservar: 'Reservar Consulta'
    },
    
    // Hero
    hero: {
      title1: 'Arte en la piel.',
      title2: 'Realismo que trasciende.',
      subtitle: 'Especialista en realismo, sombras y blackwork en proyectos de gran formato.',
      btnPortfolio: 'Ver Portfolio',
      btnConsulta: 'Reservar Consulta'
    },
    
    // Portfolio
    portfolio: {
      title: 'Portfolio',
      subtitle: 'Explora mis trabajos en diferentes estilos y técnicas',
      categories: {
        retratos: 'Retratos',
        animales: 'Animales',
        mitologicos: 'Mitológicos',
        blackwork: 'Blackwork',
        otros: 'Otros diseños'
      },
      items: {
        retrato1: {
          title: 'Retrato Realista',
          description: 'Retrato hiperrealista con detalle extremo en sombreado y texturas.',
          size: 'Grande - Antebrazo completo',
          time: '3 sesiones - 12 horas'
        },
        retrato2: {
          title: 'Retrato Facial',
          description: 'Retrato realista con expresión y detalle fotográfico en cada rasgo.',
          size: 'Grande - Zona amplia',
          time: '3 sesiones - 11 horas'
        },
        animal1: {
          title: 'Realismo Animal',
          description: 'Tatuaje de animal con técnica realista y profundidad en sombras.',
          size: 'Grande - Área extendida',
          time: '2 sesiones - 10 horas'
        },
        animal2: {
          title: 'Animal Realista',
          description: 'Diseño de animal con composición detallada y sombreado profundo.',
          size: 'Grande - Zona extendida',
          time: '2 sesiones - 9 horas'
        },
        mito1: {
          title: 'Mitología Realista',
          description: 'Diseño mitológico con composición compleja y detalle artístico.',
          size: 'Extra grande - Área completa',
          time: '4 sesiones - 16 horas'
        },
        mito2: {
          title: 'Figura Mitológica',
          description: 'Representación mitológica con técnica realista y composición dramática.',
          size: 'Extra grande - Zona completa',
          time: '4 sesiones - 15 horas'
        },
        mito3: {
          title: 'Personaje Mitológico',
          description: 'Diseño mitológico con gran detalle en expresión y anatomía.',
          size: 'Grande - Área extendida',
          time: '3 sesiones - 13 horas'
        },
        mito4: {
          title: 'Criatura Mítica',
          description: 'Criatura mitológica con sombreado realista y composición impactante.',
          size: 'Grande - Zona amplia',
          time: '3 sesiones - 14 horas'
        },
        mito5: {
          title: 'Elemento Mitológico',
          description: 'Diseño mitológico con detalle en texturas y profundidad.',
          size: 'Grande - Área definida',
          time: '3 sesiones - 12 horas'
        },
        mito6: {
          title: 'Escena Mitológica',
          description: 'Composición mitológica compleja con múltiples elementos y simbolismo.',
          size: 'Extra grande - Zona completa',
          time: '4 sesiones - 17 horas'
        },
        black1: {
          title: 'Blackwork',
          description: 'Trabajo en negro sólido con contrastes marcados y formas definidas.',
          size: 'Grande - Zona amplia',
          time: '2 sesiones - 8 horas'
        },
        black2: {
          title: 'Blackwork Ornamental',
          description: 'Diseño blackwork con patrones definidos y negro sólido intenso.',
          size: 'Grande - Área extendida',
          time: '2 sesiones - 9 horas'
        },
        retratoJesus: { title: 'Retrato de Jesús', description: 'Retrato realista de Jesús en una composición de alto contraste.' },
        retratoHombre: { title: 'Retrato masculino', description: 'Retrato de un hombre trabajado con sombras y detalle realista.' },
        retratoVirgen: { title: 'Retrato de la Virgen', description: 'Retrato de la Virgen con rosario y un trabajo detallado de luz y sombra.' },
        animalDragon: { title: 'Dragón', description: 'Dragón de gran formato trabajado con escamas, textura y sombras profundas.' },
        animalTiger2: { title: 'Tigre realista', description: 'Tigre con composición envolvente y contraste marcado.' },
        animalSwan: { title: 'Cisne', description: 'Cisne integrado en una composición de líneas y sombras en negro y gris.' },
        mitoHelmet: { title: 'Figura mitológica con casco', description: 'Figura con casco integrada en una pieza mitológica de alto contraste.' },
        mitoComposition: { title: 'Composición mitológica', description: 'Composición de figuras y escenas mitológicas en el hombro.' },
        mitoCoin: { title: 'Moneda clásica', description: 'Moneda clásica y arquitectura reunidas en una composición de inspiración mitológica.' },
        mitoAngel: { title: 'Figura angelical', description: 'Figura angelical de estilo escultórico con sombreado dramático.' },
        mitoKnight: { title: 'Caballero clásico', description: 'Caballero de inspiración clásica en una composición de gran formato.' },
        mitoGod: { title: 'Figura clásica', description: 'Figura clásica y detalles arquitectónicos en una pieza de alto contraste.' },
        mitoPortrait: { title: 'Rostro mitológico', description: 'Rostro de una figura mitológica integrado en una composición en negro y gris.' },
        otherSpace: { title: 'Universo', description: 'Composición cósmica con planeta, astronauta y elementos espaciales.' },
      },
      labels: {
        size: 'Tamaño:',
        time: 'Tiempo:'
      }
    },
    
    // Proyectos Recientes
    proyectos: {
      title: 'Tatuajes Recientes',
      items: [
        'Realismo animal - Proyecto reciente',
        'Retrato realista - Terminado',
        'Blackwork - Reciente'
      ]
    },
    
    // Evolución
    evolucion: {
      title: 'Un tatuaje, dos momentos',
      subtitle: 'La pieza de Casio, recién hecha y después de cicatrizar',
      fresh: 'RECIÉN HECHO',
      healed: 'CICATRIZADO',
      instruction: 'Desliza el control para comparar ambos momentos',
      sliderLabel: 'Comparar tatuaje recién hecho y cicatrizado'
    },
    
    // Proceso
    proceso: {
      title: 'El Proceso',
      steps: [
        {
          title: 'Nos ponemos en contacto',
          description: 'Ramiro revisa tu solicitud y te escribe por el medio que elegiste.'
        },
        {
          title: 'Definimos el diseño',
          description: 'Conversamos tu idea y hacemos una revisión detallada del diseño hasta que quede como lo imaginas.'
        },
        {
          title: 'Agendamos las sesiones',
          description: 'Cuadramos las fechas de tus sesiones de tatuaje.'
        }
      ]
    },
    
    // Sobre Mí
    sobreMi: {
      title: 'Sobre mí',
      text: [
        'Mi nombre es Ramiro y me especializo en tatuajes de gran formato, combinando técnicas de realismo, sombras y blackwork para crear piezas únicas e impactantes.',
        'Mi trayectoria me ha llevado a plasmar mi arte en diversas ciudades de {colombia} y a proyectar mi estilo a nivel internacional. He tenido el privilegio de trabajar en estudios de {brasil}, {mexico}, {alemania} y {francia}, experiencias que han enriquecido mi técnica y me han permitido conectar con la vanguardia del tatuaje global.',
        'Cada proyecto es una oportunidad para crear arte permanente. Mi filosofía se basa en la dedicación absoluta a cada detalle, desde el concepto inicial hasta la ejecución final. Trabajo con pasión en proyectos grandes y complejos que requieren planificación artística, múltiples sesiones y un compromiso total con la excelencia.',
        'Para mí, la calidad siempre está por encima de la cantidad. Prefiero trabajar en menos proyectos pero con resultados excepcionales.'
      ],
      quote: 'Cada pieza es única.\nCada proyecto es una obra.'
    },
    
    // Dónde estoy (Calendario de viajes)
    dondeEstoy: {
      badge: 'Itinerario',
      title: '¿Dónde estoy?',
      subtitle: 'Fechas de viaje y próximas ciudades',
      currentStatus: 'Ubicación actual',
      bookButton: 'Reservar Consulta',
      actionBook: 'Agendar en esta ciudad',
      directWhatsApp: 'Consultar por WhatsApp',
      liveNotice: 'Actualmente tatuando en',
      bannerNotice: 'Los cupos para cada ciudad son estrictamente limitados debido a la agenda de viajes. Se recomienda reservar con anticipación.',
      timeline: [
        {
          id: 1,
          month: 'Octubre 2026',
          monthShort: 'OCT',
          year: '2026',
          city: 'Colonia',
          country: 'Alemania',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Actualmente aquí',
          isCurrent: true,
          description: 'Residencia activa en Colonia (Alemania). Citas disponibles para tatuajes de gran formato y realismo.',
          waMessage: 'Hola Ramiro, te contacto desde tu página web. Me gustaría agendar una cita contigo en Colonia (Alemania) para Octubre.'
        },
        {
          id: 2,
          month: 'Diciembre 2026',
          monthShort: 'DIC',
          year: '2026',
          city: 'Colombia',
          country: 'Colombia',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Próximo viaje',
          isCurrent: false,
          description: 'Viaje a Colombia. Apertura de agenda para piezas nuevas, proyectos grandes y sesiones de continuación.',
          waMessage: 'Hola Ramiro, te contacto desde tu página web. Me gustaría agendar una cita contigo en Colombia para Diciembre.'
        },
        {
          id: 3,
          month: 'Febrero 2027',
          monthShort: 'FEB',
          year: '2027',
          city: 'Estados Unidos',
          country: 'Estados Unidos',
          countryCode: 'USA',
          countryKey: 'usa',
          flag: '🇺🇸',
          status: 'Guest Spot',
          isCurrent: false,
          description: 'Gira y Guest Spot en Estados Unidos. Sesiones exclusivas y proyectos personalizados.',
          waMessage: 'Hola Ramiro, te contacto desde tu página web. Me gustaría agendar una cita contigo en Estados Unidos para Febrero.'
        },
        {
          id: 4,
          month: 'Marzo 2027',
          monthShort: 'MAR',
          year: '2027',
          city: 'Colonia',
          country: 'Alemania',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Regreso a Colonia',
          isCurrent: false,
          description: 'Retorno a Colonia (Alemania). Continuación de piezas en curso y nuevas reservas.',
          waMessage: 'Hola Ramiro, te contacto desde tu página web. Me gustaría agendar una cita contigo en Colonia (Alemania) para Marzo.'
        },
        {
          id: 5,
          month: 'Abril 2027',
          monthShort: 'ABR',
          year: '2027',
          city: 'Colombia',
          country: 'Colombia',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Regreso a Colombia',
          isCurrent: false,
          description: 'Regreso a Colombia tras la gira en Europa. Agenda disponible para proyectos de alto nivel.',
          waMessage: 'Hola Ramiro, te contacto desde tu página web. Me gustaría agendar una cita contigo en Colombia para Abril.'
        }
      ]
    },
    
    // Contacto
    contacto: {
      title: 'Reserva tu proyecto',
      subtitle: 'Contáctame para comenzar a dar vida a tu idea',
      form: {
        nombre: 'Nombre',
        email: 'Email',
        descripcion: 'Descripción del proyecto',
        tamano: 'Tamaño aproximado',
        tamanoPlaceholder: 'Ej: Antebrazo completo',
        zona: 'Zona del cuerpo',
        zonaPlaceholder: 'Ej: Brazo, Pierna, Espalda',
        submit: 'Enviar consulta',
        required: '*',
        success: '¡Formulario enviado correctamente! Te contactaré pronto.'
      },
      errors: {
        nombreRequerido: 'El nombre es requerido',
        emailRequerido: 'El email es requerido',
        emailInvalido: 'Email inválido',
        descripcionRequerida: 'La descripción es requerida'
      },
      other: {
        title: 'Otras formas de contacto',
        description: 'Podés contactarme directamente por WhatsApp o seguir mi trabajo en Instagram para ver más proyectos y actualizaciones.',
        whatsapp: 'WhatsApp',
        whatsappDesc: 'Consulta directa',
        instagram: 'Instagram'
      }
    },
    
    // Footer
    footer: {
      tagline: 'Arte permanente, calidad excepcional',
      copyright: 'Todos los derechos reservados.'
    }
  },
  
  en: {
    nav: {
      inicio: 'Home',
      portfolio: 'Portfolio',
      proyectos: 'Projects',
      proceso: 'Process',
      sobreMi: 'About Me',
      dondeEstoy: 'Where am I?',
      contacto: 'Contact',
      reservar: 'Book Consultation'
    },
    
    hero: {
      title1: 'Art on skin.',
      title2: 'Realism that transcends.',
      subtitle: 'Specialist in realism, shading and blackwork in large format projects.',
      btnPortfolio: 'View Portfolio',
      btnConsulta: 'Book Consultation'
    },
    
    portfolio: {
      title: 'Portfolio',
      subtitle: 'Explore my work in different styles and techniques',
      categories: {
        retratos: 'Portraits',
        animales: 'Animals',
        mitologicos: 'Mythological',
        blackwork: 'Blackwork',
        otros: 'Other designs'
      },
      items: {
        retrato1: {
          title: 'Realistic Portrait',
          description: 'Hyperrealistic portrait with extreme detail in shading and textures.',
          size: 'Large - Full forearm',
          time: '3 sessions - 12 hours'
        },
        retrato2: {
          title: 'Facial Portrait',
          description: 'Realistic portrait with expression and photographic detail in every feature.',
          size: 'Large - Wide area',
          time: '3 sessions - 11 hours'
        },
        animal1: {
          title: 'Animal Realism',
          description: 'Animal tattoo with realistic technique and depth in shadows.',
          size: 'Large - Extended area',
          time: '2 sessions - 10 hours'
        },
        animal2: {
          title: 'Realistic Animal',
          description: 'Animal design with detailed composition and deep shading.',
          size: 'Large - Extended zone',
          time: '2 sessions - 9 hours'
        },
        mito1: {
          title: 'Realistic Mythology',
          description: 'Mythological design with complex composition and artistic detail.',
          size: 'Extra large - Full area',
          time: '4 sessions - 16 hours'
        },
        mito2: {
          title: 'Mythological Figure',
          description: 'Mythological representation with realistic technique and dramatic composition.',
          size: 'Extra large - Full zone',
          time: '4 sessions - 15 hours'
        },
        mito3: {
          title: 'Mythological Character',
          description: 'Mythological design with great detail in expression and anatomy.',
          size: 'Large - Extended area',
          time: '3 sessions - 13 hours'
        },
        mito4: {
          title: 'Mythical Creature',
          description: 'Mythological creature with realistic shading and striking composition.',
          size: 'Large - Wide zone',
          time: '3 sessions - 14 hours'
        },
        mito5: {
          title: 'Mythological Element',
          description: 'Mythological design with detail in textures and depth.',
          size: 'Large - Defined area',
          time: '3 sessions - 12 hours'
        },
        mito6: {
          title: 'Mythological Scene',
          description: 'Complex mythological composition with multiple elements and symbolism.',
          size: 'Extra large - Full zone',
          time: '4 sessions - 17 hours'
        },
        black1: {
          title: 'Blackwork',
          description: 'Solid black work with marked contrasts and defined shapes.',
          size: 'Large - Wide zone',
          time: '2 sessions - 8 hours'
        },
        black2: {
          title: 'Ornamental Blackwork',
          description: 'Blackwork design with defined patterns and intense solid black.',
          size: 'Large - Extended area',
          time: '2 sessions - 9 hours'
        },
        retratoJesus: { title: 'Portrait of Jesus', description: 'Realistic portrait of Jesus in a high-contrast composition.' },
        retratoHombre: { title: 'Portrait of a man', description: 'Portrait of a man rendered with realistic shading and detail.' },
        retratoVirgen: { title: 'Portrait of the Virgin Mary', description: 'Portrait of the Virgin Mary with a rosary and detailed light and shadow.' },
        animalDragon: { title: 'Dragon', description: 'Large-scale dragon with detailed scales, texture and deep shading.' },
        animalTiger2: { title: 'Realistic tiger', description: 'Tiger tattoo with a flowing composition and strong contrast.' },
        animalSwan: { title: 'Swan', description: 'Swan integrated into a black-and-gray composition of lines and shading.' },
        mitoHelmet: { title: 'Mythological figure in a helmet', description: 'Helmeted figure in a high-contrast mythological piece.' },
        mitoComposition: { title: 'Mythological composition', description: 'Composition of mythological figures and scenes across the shoulder.' },
        mitoCoin: { title: 'Classical coin', description: 'Classical coin and architecture in a mythology-inspired composition.' },
        mitoAngel: { title: 'Angelic figure', description: 'Sculptural angelic figure with dramatic shading.' },
        mitoKnight: { title: 'Classical knight', description: 'Classical-inspired knight in a large-scale composition.' },
        mitoGod: { title: 'Classical figure', description: 'Classical figure and architectural details in a high-contrast piece.' },
        mitoPortrait: { title: 'Mythological portrait', description: 'Face of a mythological figure integrated into a black-and-gray composition.' },
        otherSpace: { title: 'Outer space', description: 'Cosmic composition featuring a planet, an astronaut and space elements.' },
      },
      labels: {
        size: 'Size:',
        time: 'Time:'
      }
    },
    
    proyectos: {
      title: 'Recent Tattoos',
      items: [
        'Animal realism - Recent project',
        'Realistic portrait - Completed',
        'Blackwork - Recent'
      ]
    },
    
    evolucion: {
      title: 'One tattoo, two moments',
      subtitle: 'Casio’s tattoo, freshly done and after healing',
      fresh: 'FRESH',
      healed: 'HEALED',
      instruction: 'Move the slider to compare both stages',
      sliderLabel: 'Compare fresh and healed tattoo'
    },
    
    proceso: {
      title: 'The Process',
      steps: [
        {
          title: 'We get in touch',
          description: 'Ramiro reviews your request and contacts you through your preferred channel.'
        },
        {
          title: 'We define the design',
          description: 'We discuss your idea and review the design until it matches what you imagine.'
        },
        {
          title: 'We schedule the sessions',
          description: 'Together we choose the dates for your tattoo sessions.'
        }
      ]
    },
    
    sobreMi: {
      title: 'About Me',
      text: [
        'My name is Ramiro and I specialize in large format tattoos, combining realism, shading and blackwork techniques to create unique and striking pieces.',
        'My journey has taken me to showcase my art in various cities in {colombia} and project my style internationally. I have had the privilege of working in studios in {brasil}, {mexico}, {alemania} and {francia}, experiences that have enriched my technique and allowed me to connect with the vanguard of global tattooing.',
        'Each project is an opportunity to create permanent art. My philosophy is based on absolute dedication to every detail, from the initial concept to the final execution. I work with passion on large and complex projects that require artistic planning, multiple sessions and a total commitment to excellence.',
        'For me, quality is always above quantity. I prefer to work on fewer projects but with exceptional results.'
      ],
      quote: 'Each piece is unique.\nEach project is a work of art.'
    },
    
    // Where am I (Travel Calendar)
    dondeEstoy: {
      badge: 'Itinerary',
      title: 'Where am I?',
      subtitle: 'Travel dates & tour schedule',
      currentStatus: 'Current location',
      bookButton: 'Book Consultation',
      actionBook: 'Book in this city',
      directWhatsApp: 'Inquire via WhatsApp',
      liveNotice: 'Currently tattooing in',
      bannerNotice: 'Spots in each city are strictly limited due to tour scheduling. Booking in advance is highly recommended.',
      timeline: [
        {
          id: 1,
          month: 'October 2026',
          monthShort: 'OCT',
          year: '2026',
          city: 'Cologne',
          country: 'Germany',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Currently here',
          isCurrent: true,
          description: 'Studio residency in Cologne (Germany). Appointments open for large-scale realism and custom pieces.',
          waMessage: 'Hello Ramiro, I found you on your website. I would like to book an appointment with you in Cologne (Germany) for October.'
        },
        {
          id: 2,
          month: 'December 2026',
          monthShort: 'DEC',
          year: '2026',
          city: 'Colombia',
          country: 'Colombia',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Upcoming trip',
          isCurrent: false,
          description: 'Trip to Colombia. Booking calendar open for new projects and ongoing sessions.',
          waMessage: 'Hello Ramiro, I found you on your website. I would like to book an appointment with you in Colombia for December.'
        },
        {
          id: 3,
          month: 'February 2027',
          monthShort: 'FEB',
          year: '2027',
          city: 'United States',
          country: 'United States',
          countryCode: 'USA',
          countryKey: 'usa',
          flag: '🇺🇸',
          status: 'Guest Spot',
          isCurrent: false,
          description: 'US Tour and guest spot. Exclusive sessions and custom artistic projects.',
          waMessage: 'Hello Ramiro, I found you on your website. I would like to book an appointment with you in the United States for February.'
        },
        {
          id: 4,
          month: 'March 2027',
          monthShort: 'MAR',
          year: '2027',
          city: 'Cologne',
          country: 'Germany',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Back in Cologne',
          isCurrent: false,
          description: 'Return to Cologne (Germany). Continuation of existing projects and new consultations.',
          waMessage: 'Hello Ramiro, I found you on your website. I would like to book an appointment with you in Cologne (Germany) for March.'
        },
        {
          id: 5,
          month: 'April 2027',
          monthShort: 'APR',
          year: '2027',
          city: 'Colombia',
          country: 'Colombia',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Back in Colombia',
          isCurrent: false,
          description: 'Return to Colombia after the European tour. Booking open for tattoo appointments.',
          waMessage: 'Hello Ramiro, I found you on your website. I would like to book an appointment with you in Colombia for April.'
        }
      ]
    },
    
    contacto: {
      title: 'Book your project',
      subtitle: 'Contact me to start bringing your idea to life',
      form: {
        nombre: 'Name',
        email: 'Email',
        descripcion: 'Project description',
        tamano: 'Approximate size',
        tamanoPlaceholder: 'E.g: Full forearm',
        zona: 'Body area',
        zonaPlaceholder: 'E.g: Arm, Leg, Back',
        submit: 'Send inquiry',
        required: '*',
        success: 'Form submitted successfully! I will contact you soon.'
      },
      errors: {
        nombreRequerido: 'Name is required',
        emailRequerido: 'Email is required',
        emailInvalido: 'Invalid email',
        descripcionRequerida: 'Description is required'
      },
      other: {
        title: 'Other contact options',
        description: 'You can contact me directly via WhatsApp or follow my work on Instagram to see more projects and updates.',
        whatsapp: 'WhatsApp',
        whatsappDesc: 'Direct inquiry',
        instagram: 'Instagram'
      }
    },
    
    footer: {
      tagline: 'Permanent art, exceptional quality',
      copyright: 'All rights reserved.'
    }
  },
  
  pt: {
    nav: {
      inicio: 'Início',
      portfolio: 'Portfólio',
      proyectos: 'Projetos',
      proceso: 'Processo',
      sobreMi: 'Sobre Mim',
      dondeEstoy: 'Onde estou?',
      contacto: 'Contato',
      reservar: 'Agendar Consulta'
    },
    
    hero: {
      title1: 'Arte na pele.',
      title2: 'Realismo que transcende.',
      subtitle: 'Especialista em realismo, sombreamento e blackwork em projetos de grande formato.',
      btnPortfolio: 'Ver Portfólio',
      btnConsulta: 'Agendar Consulta'
    },
    
    portfolio: {
      title: 'Portfólio',
      subtitle: 'Explore meu trabalho em diferentes estilos e técnicas',
      categories: {
        retratos: 'Retratos',
        animales: 'Animais',
        mitologicos: 'Mitológicos',
        blackwork: 'Blackwork',
        otros: 'Outros desenhos'
      },
      items: {
        retrato1: {
          title: 'Retrato Realista',
          description: 'Retrato hiper-realista com detalhes extremos em sombreamento e texturas.',
          size: 'Grande - Antebraço completo',
          time: '3 sessões - 12 horas'
        },
        retrato2: {
          title: 'Retrato Facial',
          description: 'Retrato realista com expressão e detalhes fotográficos em cada traço.',
          size: 'Grande - Área ampla',
          time: '3 sessões - 11 horas'
        },
        animal1: {
          title: 'Realismo Animal',
          description: 'Tatuagem de animal com técnica realista e profundidade nas sombras.',
          size: 'Grande - Área estendida',
          time: '2 sessões - 10 horas'
        },
        animal2: {
          title: 'Animal Realista',
          description: 'Design de animal com composição detalhada e sombreamento profundo.',
          size: 'Grande - Zona estendida',
          time: '2 sessões - 9 horas'
        },
        mito1: {
          title: 'Mitologia Realista',
          description: 'Design mitológico com composição complexa e detalhes artísticos.',
          size: 'Extra grande - Área completa',
          time: '4 sessões - 16 horas'
        },
        mito2: {
          title: 'Figura Mitológica',
          description: 'Representação mitológica com técnica realista e composição dramática.',
          size: 'Extra grande - Zona completa',
          time: '4 sessões - 15 horas'
        },
        mito3: {
          title: 'Personagem Mitológico',
          description: 'Design mitológico com grande detalhe em expressão e anatomia.',
          size: 'Grande - Área estendida',
          time: '3 sessões - 13 horas'
        },
        mito4: {
          title: 'Criatura Mítica',
          description: 'Criatura mitológica com sombreamento realista e composição impactante.',
          size: 'Grande - Zona ampla',
          time: '3 sessões - 14 horas'
        },
        mito5: {
          title: 'Elemento Mitológico',
          description: 'Design mitológico com detalhes em texturas e profundidade.',
          size: 'Grande - Área definida',
          time: '3 sessões - 12 horas'
        },
        mito6: {
          title: 'Cena Mitológica',
          description: 'Composição mitológica complexa com múltiplos elementos e simbolismo.',
          size: 'Extra grande - Zona completa',
          time: '4 sessões - 17 horas'
        },
        black1: {
          title: 'Blackwork',
          description: 'Trabalho em preto sólido com contrastes marcados e formas definidas.',
          size: 'Grande - Zona ampla',
          time: '2 sessões - 8 horas'
        },
        black2: {
          title: 'Blackwork Ornamental',
          description: 'Design blackwork com padrões definidos e preto sólido intenso.',
          size: 'Grande - Área estendida',
          time: '2 sessões - 9 horas'
        },
        retratoJesus: { title: 'Retrato de Jesus', description: 'Retrato realista de Jesus em uma composição de alto contraste.' },
        retratoHombre: { title: 'Retrato masculino', description: 'Retrato de um homem com sombras e detalhes realistas.' },
        retratoVirgen: { title: 'Retrato de Nossa Senhora', description: 'Retrato de Nossa Senhora com rosário e detalhes de luz e sombra.' },
        animalDragon: { title: 'Dragão', description: 'Dragão de grande formato com escamas detalhadas, textura e sombras profundas.' },
        animalTiger2: { title: 'Tigre realista', description: 'Tigre em uma composição envolvente e com contraste marcante.' },
        animalSwan: { title: 'Cisne', description: 'Cisne integrado a uma composição de linhas e sombras em preto e cinza.' },
        mitoHelmet: { title: 'Figura mitológica com capacete', description: 'Figura com capacete em uma peça mitológica de alto contraste.' },
        mitoComposition: { title: 'Composição mitológica', description: 'Composição de figuras e cenas mitológicas no ombro.' },
        mitoCoin: { title: 'Moeda clássica', description: 'Moeda clássica e arquitetura em uma composição de inspiração mitológica.' },
        mitoAngel: { title: 'Figura angelical', description: 'Figura angelical de estilo escultórico com sombras dramáticas.' },
        mitoKnight: { title: 'Cavaleiro clássico', description: 'Cavaleiro de inspiração clássica em uma composição de grande formato.' },
        mitoGod: { title: 'Figura clássica', description: 'Figura clássica e detalhes arquitetônicos em uma peça de alto contraste.' },
        mitoPortrait: { title: 'Rosto mitológico', description: 'Rosto de uma figura mitológica integrado a uma composição em preto e cinza.' },
        otherSpace: { title: 'Universo', description: 'Composição cósmica com planeta, astronauta e elementos espaciais.' },
      },
      labels: {
        size: 'Tamanho:',
        time: 'Tempo:'
      }
    },
    
    proyectos: {
      title: 'Tatuagens Recentes',
      items: [
        'Realismo animal - Projeto recente',
        'Retrato realista - Concluído',
        'Blackwork - Recente'
      ]
    },
    
    evolucion: {
      title: 'Uma tatuagem, dois momentos',
      subtitle: 'A peça de Casio, recém-feita e depois de cicatrizada',
      fresh: 'RECÉM FEITO',
      healed: 'CICATRIZADO',
      instruction: 'Deslize o controle para comparar os dois momentos',
      sliderLabel: 'Comparar tatuagem recém-feita e cicatrizada'
    },
    
    proceso: {
      title: 'O Processo',
      steps: [
        {
          title: 'Entramos em contato',
          description: 'Ramiro analisa sua solicitação e fala com você pelo meio escolhido.'
        },
        {
          title: 'Definimos o desenho',
          description: 'Conversamos sobre sua ideia e revisamos o desenho até ficar como você imagina.'
        },
        {
          title: 'Agendamos as sessões',
          description: 'Combinamos as datas das suas sessões de tatuagem.'
        }
      ]
    },
    
    sobreMi: {
      title: 'Sobre Mim',
      text: [
        'Meu nome é Ramiro e me especializo em tatuagens de grande formato, combinando técnicas de realismo, sombreamento e blackwork para criar peças únicas e impactantes.',
        'Minha trajetória me levou a plasmar minha arte em diversas cidades da {colombia} e projetar meu estilo a nível internacional. Tive o privilégio de trabalhar em estúdios do {brasil}, {mexico}, {alemania} e {francia}, experiências que enriqueceram minha técnica e me permitiram conectar com a vanguarda da tatuagem global.',
        'Cada projeto é uma oportunidade de criar arte permanente. Minha filosofia se baseia na dedicação absoluta a cada detalhe, desde o conceito inicial até a execução final. Trabalho com paixão em projetos grandes e complexos que requerem planejamento artístico, múltiplas sessões e um compromisso total com a excelência.',
        'Para mim, a qualidade está sempre acima da quantidade. Prefiro trabalhar em menos projetos mas com resultados excepcionais.'
      ],
      quote: 'Cada peça é única.\nCada projeto é uma obra.'
    },
    
    // Onde estou (Calendário de viagens)
    dondeEstoy: {
      badge: 'Itinerário',
      title: 'Onde estou?',
      subtitle: 'Datas de viagem e próximas cidades',
      currentStatus: 'Localização atual',
      bookButton: 'Agendar Consulta',
      actionBook: 'Agendar nesta cidade',
      directWhatsApp: 'Consultar pelo WhatsApp',
      liveNotice: 'Atualmente tatuando em',
      bannerNotice: 'As vagas em cada cidade são rigorosamente limitadas devido à agenda de viagens. Recomendamos reservar com antecedência.',
      timeline: [
        {
          id: 1,
          month: 'Outubro 2026',
          monthShort: 'OUT',
          year: '2026',
          city: 'Colônia',
          country: 'Alemanha',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Atualmente aqui',
          isCurrent: true,
          description: 'Residência ativa no estúdio em Colônia (Alemanha). Horários disponíveis para tatuagens realistas e novos projetos.',
          waMessage: 'Olá Ramiro, encontrei seu site. Gostaria de agendar uma sessão com você em Colônia (Alemanha) para Outubro.'
        },
        {
          id: 2,
          month: 'Dezembro 2026',
          monthShort: 'DEZ',
          year: '2026',
          city: 'Colômbia',
          country: 'Colômbia',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Próxima viagem',
          isCurrent: false,
          description: 'Viagem para a Colômbia. Abertura de agenda para projetos novos e continuação de sessões.',
          waMessage: 'Olá Ramiro, encontrei seu site. Gostaria de agendar uma sessão com você na Colômbia para Dezembro.'
        },
        {
          id: 3,
          month: 'Fevereiro 2027',
          monthShort: 'FEV',
          year: '2027',
          city: 'Estados Unidos',
          country: 'Estados Unidos',
          countryCode: 'USA',
          countryKey: 'usa',
          flag: '🇺🇸',
          status: 'Guest Spot',
          isCurrent: false,
          description: 'Turnê e guest spot nos EUA. Sessões exclusivas e projetos personalizados.',
          waMessage: 'Olá Ramiro, encontrei seu site. Gostaria de agendar uma sessão com você nos Estados Unidos para Fevereiro.'
        },
        {
          id: 4,
          month: 'Março 2027',
          monthShort: 'MAR',
          year: '2027',
          city: 'Colônia',
          country: 'Alemanha',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Retorno a Colônia',
          isCurrent: false,
          description: 'Retorno a Colônia (Alemanha). Continuação de peças e novas consultas.',
          waMessage: 'Olá Ramiro, encontrei seu site. Gostaria de agendar uma sessão com você em Colônia (Alemanha) para Março.'
        },
        {
          id: 5,
          month: 'Abril 2027',
          monthShort: 'ABR',
          year: '2027',
          city: 'Colômbia',
          country: 'Colômbia',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Retorno à Colômbia',
          isCurrent: false,
          description: 'Retorno à Colômbia após a turnê europeia. Agenda disponível para sessões.',
          waMessage: 'Olá Ramiro, encontrei seu site. Gostaria de agendar uma sessão com você na Colômbia para Abril.'
        }
      ]
    },
    
    contacto: {
      title: 'Agende seu projeto',
      subtitle: 'Entre em contato para começar a dar vida à sua ideia',
      form: {
        nombre: 'Nome',
        email: 'Email',
        descripcion: 'Descrição do projeto',
        tamano: 'Tamanho aproximado',
        tamanoPlaceholder: 'Ex: Antebraço completo',
        zona: 'Área do corpo',
        zonaPlaceholder: 'Ex: Braço, Perna, Costas',
        submit: 'Enviar consulta',
        required: '*',
        success: 'Formulário enviado com sucesso! Entrarei em contato em breve.'
      },
      errors: {
        nombreRequerido: 'Nome é obrigatório',
        emailRequerido: 'Email é obrigatório',
        emailInvalido: 'Email inválido',
        descripcionRequerida: 'Descrição é obrigatória'
      },
      other: {
        title: 'Outras formas de contato',
        description: 'Você pode me contatar diretamente pelo WhatsApp ou seguir meu trabalho no Instagram para ver mais projetos e atualizações.',
        whatsapp: 'WhatsApp',
        whatsappDesc: 'Consulta direta',
        instagram: 'Instagram'
      }
    },
    
    footer: {
      tagline: 'Arte permanente, qualidade excepcional',
      copyright: 'Todos os direitos reservados.'
    }
  },
  
  de: {
    nav: {
      inicio: 'Startseite',
      portfolio: 'Portfolio',
      proyectos: 'Projekte',
      proceso: 'Prozess',
      sobreMi: 'Über Mich',
      dondeEstoy: 'Wo bin ich?',
      contacto: 'Kontakt',
      reservar: 'Beratung Buchen'
    },
    
    hero: {
      title1: 'Kunst auf der Haut.',
      title2: 'Realismus, der transzendiert.',
      subtitle: 'Spezialist für Realismus, Schattierungen und Blackwork in großformatigen Projekten.',
      btnPortfolio: 'Portfolio Ansehen',
      btnConsulta: 'Beratung Buchen'
    },
    
    portfolio: {
      title: 'Portfolio',
      subtitle: 'Entdecken Sie meine Arbeiten in verschiedenen Stilen und Techniken',
      categories: {
        retratos: 'Porträts',
        animales: 'Tiere',
        mitologicos: 'Mythologisch',
        blackwork: 'Blackwork',
        otros: 'Andere Designs'
      },
      items: {
        retrato1: {
          title: 'Realistisches Porträt',
          description: 'Hyperrealistisches Porträt mit extremen Details in Schattierung und Texturen.',
          size: 'Groß - Voller Unterarm',
          time: '3 Sitzungen - 12 Stunden'
        },
        retrato2: {
          title: 'Gesichtsporträt',
          description: 'Realistisches Porträt mit Ausdruck und fotografischen Details in jedem Merkmal.',
          size: 'Groß - Weiter Bereich',
          time: '3 Sitzungen - 11 Stunden'
        },
        animal1: {
          title: 'Tier-Realismus',
          description: 'Tier-Tattoo mit realistischer Technik und Tiefe in Schatten.',
          size: 'Groß - Erweiterter Bereich',
          time: '2 Sitzungen - 10 Stunden'
        },
        animal2: {
          title: 'Realistisches Tier',
          description: 'Tierdesign mit detaillierter Komposition und tiefer Schattierung.',
          size: 'Groß - Erweiterte Zone',
          time: '2 Sitzungen - 9 Stunden'
        },
        mito1: {
          title: 'Realistische Mythologie',
          description: 'Mythologisches Design mit komplexer Komposition und künstlerischen Details.',
          size: 'Extra groß - Vollständiger Bereich',
          time: '4 Sitzungen - 16 Stunden'
        },
        mito2: {
          title: 'Mythologische Figur',
          description: 'Mythologische Darstellung mit realistischer Technik und dramatischer Komposition.',
          size: 'Extra groß - Vollständige Zone',
          time: '4 Sitzungen - 15 Stunden'
        },
        mito3: {
          title: 'Mythologischer Charakter',
          description: 'Mythologisches Design mit großartigen Details in Ausdruck und Anatomie.',
          size: 'Groß - Erweiterter Bereich',
          time: '3 Sitzungen - 13 Stunden'
        },
        mito4: {
          title: 'Mythische Kreatur',
          description: 'Mythologische Kreatur mit realistischer Schattierung und eindrucksvoller Komposition.',
          size: 'Groß - Weite Zone',
          time: '3 Sitzungen - 14 Stunden'
        },
        mito5: {
          title: 'Mythologisches Element',
          description: 'Mythologisches Design mit Details in Texturen und Tiefe.',
          size: 'Groß - Definierter Bereich',
          time: '3 Sitzungen - 12 Stunden'
        },
        mito6: {
          title: 'Mythologische Szene',
          description: 'Komplexe mythologische Komposition mit mehreren Elementen und Symbolik.',
          size: 'Extra groß - Vollständige Zone',
          time: '4 Sitzungen - 17 Stunden'
        },
        black1: {
          title: 'Blackwork',
          description: 'Feste schwarze Arbeit mit markanten Kontrasten und definierten Formen.',
          size: 'Groß - Weite Zone',
          time: '2 Sitzungen - 8 Stunden'
        },
        black2: {
          title: 'Ornamentales Blackwork',
          description: 'Blackwork-Design mit definierten Mustern und intensivem festem Schwarz.',
          size: 'Groß - Erweiterter Bereich',
          time: '2 Sitzungen - 9 Stunden'
        },
        retratoJesus: { title: 'Jesus-Porträt', description: 'Realistisches Jesus-Porträt in einer kontrastreichen Komposition.' },
        retratoHombre: { title: 'Männerporträt', description: 'Männerporträt mit realistischen Schattierungen und Details.' },
        retratoVirgen: { title: 'Porträt der Jungfrau Maria', description: 'Porträt der Jungfrau Maria mit Rosenkranz und ausgeprägtem Licht-und-Schatten-Spiel.' },
        animalDragon: { title: 'Drache', description: 'Großflächiger Drache mit detaillierten Schuppen, Textur und tiefen Schattierungen.' },
        animalTiger2: { title: 'Realistischer Tiger', description: 'Tiger-Tattoo mit fließender Komposition und starkem Kontrast.' },
        animalSwan: { title: 'Schwan', description: 'Schwan in einer Schwarz-Weiß-Komposition aus Linien und Schattierungen.' },
        mitoHelmet: { title: 'Mythologische Figur mit Helm', description: 'Helmfigur in einem kontrastreichen mythologischen Motiv.' },
        mitoComposition: { title: 'Mythologische Komposition', description: 'Komposition mythologischer Figuren und Szenen auf der Schulter.' },
        mitoCoin: { title: 'Antike Münze', description: 'Antike Münze und Architektur in einer mythologisch inspirierten Komposition.' },
        mitoAngel: { title: 'Engelsfigur', description: 'Engelsfigur im Skulpturenstil mit dramatischer Schattierung.' },
        mitoKnight: { title: 'Klassischer Ritter', description: 'Klassisch inspirierter Ritter in einer großflächigen Komposition.' },
        mitoGod: { title: 'Klassische Figur', description: 'Klassische Figur und architektonische Details in einem kontrastreichen Motiv.' },
        mitoPortrait: { title: 'Mythologisches Porträt', description: 'Gesicht einer mythologischen Figur in einer Schwarz-Weiß-Komposition.' },
        otherSpace: { title: 'Weltraum', description: 'Kosmische Komposition mit Planet, Astronaut und Weltraumelementen.' },
      },
      labels: {
        size: 'Größe:',
        time: 'Zeit:'
      }
    },
    
    proyectos: {
      title: 'Neueste Tattoos',
      items: [
        'Tier-Realismus - Aktuelles Projekt',
        'Realistisches Porträt - Abgeschlossen',
        'Blackwork - Aktuell'
      ]
    },
    
    evolucion: {
      title: 'Ein Tattoo, zwei Momente',
      subtitle: 'Casios Tattoo, frisch gestochen und nach dem Abheilen',
      fresh: 'FRISCH',
      healed: 'VERHEILT',
      instruction: 'Bewege den Regler, um beide Phasen zu vergleichen',
      sliderLabel: 'Frisches und abgeheiltes Tattoo vergleichen'
    },
    
    proceso: {
      title: 'Der Prozess',
      steps: [
        {
          title: 'Wir nehmen Kontakt auf',
          description: 'Ramiro prüft Ihre Anfrage und meldet sich über den von Ihnen gewählten Kontaktweg.'
        },
        {
          title: 'Wir legen das Design fest',
          description: 'Wir besprechen Ihre Idee und passen das Design an, bis es Ihren Vorstellungen entspricht.'
        },
        {
          title: 'Wir planen die Sitzungen',
          description: 'Gemeinsam vereinbaren wir die Termine für Ihre Tattoositzungen.'
        }
      ]
    },
    
    sobreMi: {
      title: 'Über Mich',
      text: [
        'Mein Name ist Ramiro und ich spezialisiere mich auf großformatige Tattoos, indem ich Realismus-, Schattierungs- und Blackwork-Techniken kombiniere, um einzigartige und eindrucksvolle Stücke zu schaffen.',
        'Meine Reise hat mich dazu gebracht, meine Kunst in verschiedenen Städten in {colombia} zu präsentieren und meinen Stil international zu projizieren. Ich hatte das Privileg, in Studios in {brasil}, {mexico}, {alemania} und {francia} zu arbeiten, Erfahrungen, die meine Technik bereichert haben und es mir ermöglicht haben, mich mit der Avantgarde des globalen Tätowierens zu verbinden.',
        'Jedes Projekt ist eine Gelegenheit, permanente Kunst zu schaffen. Meine Philosophie basiert auf absoluter Hingabe an jedes Detail, vom ersten Konzept bis zur endgültigen Ausführung. Ich arbeite mit Leidenschaft an großen und komplexen Projekten, die künstlerische Planung, mehrere Sitzungen und ein totales Engagement für Exzellenz erfordern.',
        'Für mich steht Qualität immer über Quantität. Ich arbeite lieber an weniger Projekten, aber mit außergewöhnlichen Ergebnissen.'
      ],
      quote: 'Jedes Stück ist einzigartig.\nJedes Projekt ist ein Kunstwerk.'
    },
    
    // Wo bin ich (Reisekalender)
    dondeEstoy: {
      badge: 'Reiseplan',
      title: 'Wo bin ich?',
      subtitle: 'Reisedaten & Tour-Plan',
      currentStatus: 'Aktueller Standort',
      bookButton: 'Beratung Buchen',
      actionBook: 'In dieser Stadt buchen',
      directWhatsApp: 'Über WhatsApp anfragen',
      liveNotice: 'Aktuell tätig in',
      bannerNotice: 'Die Plätze in jeder Stadt sind aufgrund der Reiseroute streng limitiert. Eine frühzeitige Buchung wird empfohlen.',
      timeline: [
        {
          id: 1,
          month: 'Oktober 2026',
          monthShort: 'OKT',
          year: '2026',
          city: 'Köln',
          country: 'Deutschland',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Aktuell hier',
          isCurrent: true,
          description: 'Studio-Residenz in Köln (Deutschland). Termine für großflächige Realismus-Projekte und neue Entwürfe.',
          waMessage: 'Hallo Ramiro, ich habe dich über deine Website gefunden. Ich möchte einen Termin in Köln (Deutschland) für Oktober anfragen.'
        },
        {
          id: 2,
          month: 'Dezember 2026',
          monthShort: 'DEZ',
          year: '2026',
          city: 'Kolumbien',
          country: 'Kolumbien',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Nächste Reise',
          isCurrent: false,
          description: 'Reise nach Kolumbien. Buchungsstart für neue Projekte und Folgesitzungen.',
          waMessage: 'Hallo Ramiro, ich habe dich über deine Website gefunden. Ich möchte einen Termin in Kolumbien für Dezember anfragen.'
        },
        {
          id: 3,
          month: 'Februar 2027',
          monthShort: 'FEB',
          year: '2027',
          city: 'Vereinigte Staaten',
          country: 'Vereinigte Staaten',
          countryCode: 'USA',
          countryKey: 'usa',
          flag: '🇺🇸',
          status: 'Gastauftritt',
          isCurrent: false,
          description: 'USA-Tour und Gastauftritt. Exklusive Sessions und maßgeschneiderte Entwürfe.',
          waMessage: 'Hallo Ramiro, ich habe dich über deine Website gefunden. Ich möchte einen Termin in den USA für Februar anfragen.'
        },
        {
          id: 4,
          month: 'März 2027',
          monthShort: 'MÄR',
          year: '2027',
          city: 'Köln',
          country: 'Deutschland',
          countryCode: 'GER',
          countryKey: 'germany',
          flag: '🇩🇪',
          status: 'Zurück in Köln',
          isCurrent: false,
          description: 'Rückkehr nach Köln (Deutschland). Fortsetzung von Projekten und neue Beratungen.',
          waMessage: 'Hallo Ramiro, ich habe dich über deine Website gefunden. Ich möchte einen Termin in Köln (Deutschland) für März anfragen.'
        },
        {
          id: 5,
          month: 'April 2027',
          monthShort: 'APR',
          year: '2027',
          city: 'Kolumbien',
          country: 'Kolumbien',
          countryCode: 'COL',
          countryKey: 'colombia',
          flag: '🇨🇴',
          status: 'Zurück in Kolumbien',
          isCurrent: false,
          description: 'Rückkehr nach Kolumbien nach der Europa-Tour. Termine verfügbar für anspruchsvolle Projekte.',
          waMessage: 'Hallo Ramiro, ich habe dich über deine Website gefunden. Ich möchte einen Termin in Kolumbien für April anfragen.'
        }
      ]
    },
    
    contacto: {
      title: 'Buchen Sie Ihr Projekt',
      subtitle: 'Kontaktieren Sie mich, um Ihre Idee zum Leben zu erwecken',
      form: {
        nombre: 'Name',
        email: 'Email',
        descripcion: 'Projektbeschreibung',
        tamano: 'Ungefähre Größe',
        tamanoPlaceholder: 'Z.B: Voller Unterarm',
        zona: 'Körperbereich',
        zonaPlaceholder: 'Z.B: Arm, Bein, Rücken',
        submit: 'Anfrage senden',
        required: '*',
        success: 'Formular erfolgreich gesendet! Ich werde mich bald bei Ihnen melden.'
      },
      errors: {
        nombreRequerido: 'Name ist erforderlich',
        emailRequerido: 'Email ist erforderlich',
        emailInvalido: 'Ungültige Email',
        descripcionRequerida: 'Beschreibung ist erforderlich'
      },
      other: {
        title: 'Weitere Kontaktmöglichkeiten',
        description: 'Sie können mich direkt über WhatsApp kontaktieren oder meiner Arbeit auf Instagram folgen, um mehr Projekte und Updates zu sehen.',
        whatsapp: 'WhatsApp',
        whatsappDesc: 'Direkte Anfrage',
        instagram: 'Instagram'
      }
    },
    
    footer: {
      tagline: 'Permanente Kunst, außergewöhnliche Qualität',
      copyright: 'Alle Rechte vorbehalten.'
    }
  }
};

export const countries = {
  es: {
    colombia: 'Colombia',
    brasil: 'Brasil',
    mexico: 'México',
    alemania: 'Alemania',
    francia: 'Francia',
    estadosUnidos: 'Estados Unidos'
  },
  en: {
    colombia: 'Colombia',
    brasil: 'Brazil',
    mexico: 'Mexico',
    alemania: 'Germany',
    francia: 'France',
    estadosUnidos: 'United States'
  },
  pt: {
    colombia: 'Colômbia',
    brasil: 'Brasil',
    mexico: 'México',
    alemania: 'Alemanha',
    francia: 'França',
    estadosUnidos: 'Estados Unidos'
  },
  de: {
    colombia: 'Kolumbien',
    brasil: 'Brasilien',
    mexico: 'Mexiko',
    alemania: 'Deutschland',
    francia: 'Frankreich',
    estadosUnidos: 'Vereinigte Staaten'
  }
};
